<template>
  <div class="center">
    <!-- 返回按键 -->
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 考试查询主体 -->
    <div class="examInquiryBox">
      <!-- 统计盒子 -->
      <div class="statisticalBox">
        <div
          class="card"
          v-for="(item, index) in imgArr"
          :key="index"
          @click="toCorrect(item)"
        >
          <img :src="item.imgUrl" alt="" />
          <p>
            <span>{{ item.lable }}</span>
            <span>{{ item.text }}</span>
            <span>{{ item.unit }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["changes"],
  data() {
    return {
      imgArr: [
        {
          id: "1",
          lable: "应参考试人数：",
          text: this.$parent.$children[0].rowData.StudentCount,
          unit: "人",
          imgUrl: require("@/assets/monitoring/2494.png"),
        },
        {
          id: "2",
          lable: "正在考试人数：",
          text: this.$parent.$children[0].rowData.onlineCount,
          unit: "人",
          imgUrl: require("@/assets/monitoring/2495.png"),
        },
        {
          id: "3",
          lable: "已交试卷人数：",
          text: this.$parent.$children[0].rowData.haveCount,
          unit: "人",
          imgUrl: require("@/assets/monitoring/2496.png"),
        },
        {
          id: "4",
          lable: "未参加考试人数：",
          text: this.$parent.$children[0].rowData.notJoinCount,
          unit: "人",
          imgUrl: require("@/assets/monitoring/2497.png"),
        },
      ],
    };
  },
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.changes(0);
    },
    toCorrect(item) {
      // && item.text>0
      if (item.id == 4 ) {
        // 2024/6/19 产品需求跳转对应的批改试卷 ExamID
        this.$router.push({
          path: "/correcting",
          query: { examID: this.$parent.rowObj.ExamID }
        });
        sessionStorage.setItem('examInfo',JSON.stringify(this.$parent.rowObj))
        console.log(this.$parent.rowObj);
      }
      console.log(item);
    },
  },
  created() {},
  activated() {},
};
</script>

<style lang="scss" scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

// 考试查询主体css
.examInquiryBox {
  height: 650px;
  .statisticalBox {
    margin-top: 161px;
    margin-left: 96px;
    margin-right: 96px;
    height: 280px;
    align-content: center;
    justify-content: space-between;
    background: #ffffff;
    display: flex;
    .card {
      height: 280px;
      text-align: center;
      cursor: pointer;
      img {
        display: block;
      }
      p {
        position: relative;
        margin-top: 40px;
        span:nth-child(2) {
          color: #1890ff;
          margin-right: 10px;
        }
        span {
          width: 126px;
          height: 18px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 18px;
          color: #333333;
          opacity: 1;
        }
      }
    }
  }
}
</style>